// Constants
import {
  SET_WORK_HISTORY_FILTERS_ACTION,
  SET_USER_ID_ACTION,
  CLEAR_WORK_HISTORY_FILTERS_ACTION,
} from "../../redux/constants";

const INITIAL_STATE = {
  filters: {},
  userId: null,
};

export default function workHistoryReducer(state = INITIAL_STATE, action) {
  // NOSONAR
  switch (action.type) {
    case SET_WORK_HISTORY_FILTERS_ACTION: //redundant
      return {
        ...state,
        filters: action.filters,
      };
    case SET_USER_ID_ACTION:
      return {
        ...state,
        userId: action.userId,
      };
    case CLEAR_WORK_HISTORY_FILTERS_ACTION:
      return { state: INITIAL_STATE };
    default:
      return state;
  }
}
